import React from "react";
import "./primary-list.scss";

export const PrimaryList = ({
  section,
}: {
  section: { title: string; body: string }[];
}) => {
  return (
    <div className="primary-list--wrapper">
      {section.map((s, i) => {
        return (
          <div key={i} className="primary-list--item">
            <div className="primary-list--box">
              <h2>{i + 1}</h2>
            </div>
            <div className="primary-list--text">
              <p>
                <strong>{s.title}</strong>
              </p>
              <p>{s.body}</p>
            </div>
          </div>
        );
      })}
      <div className="primary-list--connecter-item"></div>
    </div>
  );
};
